import Swiper, { Navigation, Scrollbar, Autoplay } from "swiper";
import "swiper/swiper.min.css";
import "swiper/modules/scrollbar/scrollbar.min.css";

import { tablet, laptop } from "@/App/breakpoints";

import "./style.css";

export default class SpecialismsCarousel {
  static selector = ".specialisms-carousel";

  constructor(block) {
    this.block = block;

    this.itemsContainer = this.block.querySelector(
      ".specialisms-carousel__articles"
    );
    this.prevButton = this.block.querySelector(".swiper-button-prev");
    this.nextButton = this.block.querySelector(".swiper-button-next");
    this.scrollbar = this.block.querySelector(".article-navigation__scrollbar");
  }

  onReady = () => {
    this.swiper = new Swiper(this.itemsContainer, {
      modules: [Scrollbar, Navigation, Autoplay],
      wrapperClass: "specialisms-carousel__articles-inner",
      slideActiveClass: "specialisms-carousel__articles-item--active",
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton
      },
      slideToClickedSlide: true,
      scrollbar: {
        el: this.scrollbar,
        draggable: true,
        dragClass: "article-navigation__scrollbar-drag",
        hide: false
      },
      autoplay: {
        delay: 5000
      },
      slidesPerView: 4,
      spaceBetween: 24,
      loop: true,
      breakpoints: {
        [tablet]: {
          spaceBetween: 40
        },
        [laptop]: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 4
        },
        1680: {
          slidesPerView: 5
        }
      }
    });
  };
  onResize = () => { };
  onDestroy = () => {
    this.swiper.destroy();
  };
}
